class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    const weightData = document.getElementById('cart-notification-weight-data');
    const warningContainer = document.getElementById('cart-notification-weight-warning');
    const progressBarContainer = document.getElementById('cart-notification-progress-bar');
    
    if (weightData) {
      const totalPrice = parseInt(weightData.getAttribute('data-total-price'), 10);
      const totalWeight = parseInt(weightData.getAttribute('data-total-weight'), 10);
      
      if (warningContainer) {
        if (totalPrice >= 119900 && totalWeight > 11900) {
          const weightKg = (totalWeight / 1000.0).toFixed(2);
          warningContainer.innerHTML = `
            <div class="cart-shipping-warning" style="margin: 10px 16px 15px 16px;">
              <div class="cart-shipping-warning__content" style="
                background: #fff5f5; 
                border: 1px solid #ffc1c1; 
                border-radius: 8px; 
                padding: 10px 12px; 
                display: flex; 
                align-items: flex-start; 
                gap: 10px;
                box-shadow: 0 2px 6px rgba(217, 56, 56, 0.05);
                animation: fadeInWarning 0.3s ease-out;
              ">
                <style>
                  @keyframes fadeInWarning {
                    from { opacity: 0; transform: translateY(-5px); }
                    to { opacity: 1; transform: translateY(0); }
                  }
                </style>
                <div class="cart-shipping-warning__icon" style="color: #d93838; flex-shrink: 0; margin-top: 1px; display: flex; align-items: center;">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                    <line x1="12" y1="9" x2="12" y2="13"></line>
                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                  </svg>
                </div>
                <div class="cart-shipping-warning__text-container">
                  <h4 style="margin: 0 0 2px 0; font-size: 1.2rem; font-weight: 600; color: #b32424; font-family: inherit; line-height: 1.2;">
                    El envío gratis no aplica
                  </h4>
                  <p style="margin: 0; font-size: 1.1rem; color: #5a2c2c; line-height: 1.3; font-family: inherit;">
                    El peso es de <strong>${weightKg} kg</strong> (límite 11.9 kg).
                  </p>
                </div>
              </div>
            </div>
          `;
        } else {
          warningContainer.innerHTML = '';
        }
      }

      if (progressBarContainer) {
        if (totalWeight > 11900) {
          progressBarContainer.innerHTML = '';
        } else {
          const remaining = 119900 - totalPrice;
          const percentage = Math.min((totalPrice / 119900) * 100, 100);
          
          if (percentage >= 100) {
            progressBarContainer.innerHTML = `
              <div class="cart-progress-bar__wrapper" style="margin: 1rem 0 1.5rem 0;">
                <div class="cart-progress-bar__message is-unlocked">
                  <span class="cart-progress-bar__text">
                    ¡Felicidades! Tienes <strong>envío gratis</strong>.
                  </span>
                </div>
                <div class="cart-progress-bar__track">
                  <div class="cart-progress-bar__fill is-complete" style="width: 100%;">
                    <div class="cart-progress-bar__badge is-complete">
                      <svg class="cart-progress-bar__icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            `;
          } else {
            const remainingPesos = (remaining / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            progressBarContainer.innerHTML = `
              <div class="cart-progress-bar__wrapper" style="margin: 1rem 0 1.5rem 0;">
                <div class="cart-progress-bar__message">
                  <span class="cart-progress-bar__text">
                    Te faltan <strong>$${remainingPesos}</strong> para obtener <strong>envío gratis</strong>.
                  </span>
                </div>
                <div class="cart-progress-bar__track">
                  <div class="cart-progress-bar__fill" style="width: ${percentage}%;">
                    <div class="cart-progress-bar__badge">
                      <svg class="cart-progress-bar__icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="1" y="3" width="15" height="13"></rect>
                        <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
                        <circle cx="5.5" cy="18.5" r="2.5"></circle>
                        <circle cx="18.5" cy="18.5" r="2.5"></circle>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            `;
          }
        }
      }
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
